import en from './locale/en';
import enUS from './locale/en-US';

const defaultLocale = en;
const supportedLocales = {
  en,
  "en-US": enUS
}

const locale = navigator.language;
const combinedLocale = MergeRecursive(defaultLocale, (supportedLocales[locale] || {}));
export default combinedLocale;


/*
* Function MergeRecursive({},{})
*/
function MergeRecursive(obj1, obj2) {

  for (let key in obj2) {
    try {
      // Property in destination object set; update its value.
      if ( obj2[key].constructor == Object ) {
        obj1[key] = MergeRecursive(obj1[key], obj2[key]);

      } else {
        obj1[key] = obj2[key];

      }

    } catch(e) {
      // Property in destination object not set; create it and set its value.
      obj1[key] = obj2[key];

    }
  }

  return obj1;
}